import { Text, View } from '@react-pdf/renderer';

import { commonStyles } from 'src/common/pdf/common.styles';
import { currencyFormatter } from 'src/features/billing/invoices/forms/cells/utils';
import { styles } from 'src/features/billing/invoices/pdf/styles';

interface SimplePaymentsLineProps {
  paymentAmount: number;
}
export function SimplePaymentsLine({ paymentAmount }: SimplePaymentsLineProps) {
  return (
    <View style={styles.subTotalStyle}>
      <Text style={commonStyles.strong}>Payments</Text>
      <Text>{currencyFormatter(paymentAmount)}</Text>
    </View>
  );
}
